import type {} from "@lit/react";
import { Avatar as AvatarElement, } from "@vaadin/avatar/vaadin-avatar.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { AvatarElement, };
export type AvatarEventMap = Readonly<{}>;
const events = {} as AvatarEventMap;
export type AvatarProps = WebComponentProps<AvatarElement, AvatarEventMap>;
export const Avatar = createComponent({
    elementClass: AvatarElement, events, react: React, tagName: "vaadin-avatar"
});
